module.exports = __webpack_public_path__ + "static/media/avaldao.d12dfc0d.svg";